import { render, staticRenderFns } from "./SaveCart.vue?vue&type=template&id=1a98879b&scoped=true&"
import script from "./SaveCart.vue?vue&type=script&lang=js&"
export * from "./SaveCart.vue?vue&type=script&lang=js&"
import style0 from "./SaveCart.vue?vue&type=style&index=0&id=1a98879b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98879b",
  null
  
)

export default component.exports